import React, { useRef } from 'react'
import { observer } from 'mobx-react'
import { DataTable } from '@softwaredev_cegeka/stix-data-table'
import { Menu } from '@softwaredev_cegeka/stix-core/dist/components'

function SupplierTable(props) {
    const { loading, suppliers, rowSelectHandler } = props

    const columns = useRef([
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Tenants',
            accessor: 'tenants',
            Cell: ({ cell }) => {
                return cell.value
                    ? cell.value.map(tenant => tenant.name).join(', ')
                    : ''
            },
        },
        {
            Header: 'Domains',
            accessor: 'email',
        },
    ]).current
    const memData = React.useMemo(() => suppliers, [suppliers])

    return suppliers ? (
        <>
            <DataTable
                loading={props.loading}
                filters
                data={memData}
                columns={[
                    ...columns,
                    {
                        Header: () => null,
                        id: 'menu',
                        Cell: selectedRow => (
                            <Menu.Option
                                contextMenu={[
                                    {
                                        name: `Edit supplier`,
                                        icon: 'edit',
                                        onClick: () => {
                                            rowSelectHandler(selectedRow)
                                        },
                                    },
                                    {
                                        name: 'Remove',
                                        icon: 'delete',
                                        onClick: () => {
                                            console.log(
                                                'deleteAction not implemented'
                                            )
                                        },
                                    },
                                ]}
                                icon={'actions-vert'}
                            />
                        ),
                        width: '1%',
                    },
                ]}
                pageSize={suppliers.length > 0 ? suppliers.length : 1}
                manualPagination
                variant={'compact'}
            />
        </>
    ) : (
        <>
            <DataTable
                loading={loading}
                filters
                data={memData}
                columns={[...columns]}
                pageSize={suppliers.length > 0 ? suppliers.length : 1}
                manualPagination
                variant={'compact'}
            />
        </>
    )
}

export default observer(SupplierTable)
